// removed by extract-text-webpack-plugin
module.exports = {"PercentBar":"PercentBar__3xs13ye0fNn9","label":"label__vLvu3Smomry3","progressText":"progressText__11_QN2SNy6k9","progressBar":"progressBar__h-6XrigqukNa"};